import request from '@/utils/request'

// 获取商户下级商户
export const getDescendants = (params: any) => request({
    url: '/manage/merchant/' + params.merchant_no + '/descendants',
    method: 'get',
    params
})